import * as React from 'react';
import styled from 'styled-components';

import { DashboardContent } from '../../assets/contents/dashboard.content';
import { fontWeights } from '../../ui/inline-styles/variables';
import { withLocale } from '../contexts/locale.context';
import { Locale } from '../enums/locale.enum';

interface Props {
  locale: Locale;
  localizedContent: DashboardContent;
}

interface States {
  date: Date;
}

const StDateClockContainer = styled.div`
  display: flex;
`;

const StClock = styled.time`
  margin: 0 16px 0 0;
  font-size: 6rem;
  font-weight: ${fontWeights.regular};
  line-height: 1.25;
  color: #ffffff;
`;

const StClockColon = styled.span`
  display: inline-block;
  transform: translateY(-4px);
  margin: 0 0 0 8px;
  font-size: 6rem;
  font-weight: ${fontWeights.regular};
  color: #ffffff;
`;

const StPeriodDateGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StPeriod = styled.span`
  font-size: 2rem;
  font-weight: ${fontWeights.regular};
  line-height: 1.33;
  color: #ffffff;
`;

const StDate = styled.span`
  font-size: 1.75rem;
  font-weight: ${fontWeights.regular};
  line-height: 1.43;
  color: #ffffff;
  opacity: 0.7;
`;

class DateClockContainer extends React.Component<Props, States> {
  timer: NodeJS.Timeout;

  constructor(props: any) {
    super(props);

    this.state = {
      date: this.getKSTDate(),
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => this.tick(this.getKSTDate()), 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  getKSTDate = (): Date => {
    const oneMin: number = 60000;
    const oneHour: number = 3600000;
    const KSTOffset: number = 9;

    const now = new Date();
    const tz: number = now.getTime() + now.getTimezoneOffset() * oneMin + KSTOffset * oneHour;

    now.setTime(tz);

    return now;
  };

  tick = (date: Date) => {
    if (date.getSeconds() === 0) {
      this.setState({
        date,
      });
    }
  };

  render() {
    const { locale, localizedContent } = this.props;
    const { date } = this.state;

    const year: number = date.getFullYear();
    const month: string = date.toLocaleString(localizedContent.dateLocation.monthLocale, { month: 'short' });
    const day: number = date.getDate();
    const hours: number = date.getHours();
    const minutes: number = date.getMinutes();
    const period: string = hours > 11 ? 'PM' : 'AM';

    return (
      <StDateClockContainer>
        <StClock>
          {hours > 12 ? `${hours - 12}` : hours}
          <StClockColon>:</StClockColon>
          {minutes < 10 ? `0${minutes}` : minutes}
        </StClock>
        <StPeriodDateGroup>
          <StPeriod>{period}</StPeriod>
          <StDate>{locale === Locale.English ? `${day} ${month}, ${year}` : `${year}년 ${month} ${day}일`}</StDate>
        </StPeriodDateGroup>
      </StDateClockContainer>
    );
  }
}

export default withLocale(DateClockContainer);



// WEBPACK FOOTER //
// ./src/app/dashboard/containers/DateClock.container.tsx